export enum EndAction {
  LoadNext = 'load-next',
  None = 'none',
  PlayNext = 'play-next',
}
